module.exports = "/assets/thermokon-wrf04.png";